import { useEffect, useRef, useState } from "react";

function LazyRender({ children, rootMargin = "200px" }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} style={{ minHeight: 0 }}>
      {visible ? children : <div style={{ opacity: 0.3 }}>Carregando</div>}
    </div>
  );

}

export default LazyRender